import { UPDATE } from "@/data/content";
import { Diamond } from "@/components/decor";
import { Reveal } from "@/components/Reveal";

export default function Resources() {
  return (
    <section
      id="latest-update"
      data-testid="latest-update-section"
      className="section-pad bg-paper"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <h2 className="font-display text-h2-sm font-semibold tracking-tight text-ink md:text-h2">
            {UPDATE.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div
            className="border-beam relative mt-8 max-w-3xl overflow-hidden rounded-2xl border border-line bg-card p-6 sm:p-8 md:mt-12"
            data-testid="latest-update-card"
          >
            <p className="flex items-center gap-3 text-label uppercase text-accent">
              <Diamond className="bg-signal" />
              {UPDATE.label}
            </p>
            <p className="mt-3 text-body-sm text-ink/65 md:text-body">{UPDATE.text}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {UPDATE.chips.map((c) => (
                <span
                  key={c}
                  className="hairline rounded-full border-line bg-paper px-3 py-1 text-tag text-accent"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
